import React from 'react';
import { Col } from 'antd';
import { InputNumberWrapper } from './styles';
import * as S from './styles';

export function RpnFormItemFinal() {
	return (
		<Col span={11}>
			<S.CustomFormItem name="max_rpn">
				<InputNumberWrapper min={0} placeholder="0" name="min" />
			</S.CustomFormItem>
		</Col>
	);
}
